import cx from 'classnames'
import { WeightName, WeightValuesMap } from './util'
import Styles from './FontWeight.module.scss'
import { forwardRef } from 'react'

interface Props {
  weight: WeightName
  onClick: () => void
  active: boolean
  onKeyDown?: (e: React.KeyboardEvent) => void
}

export const FontWeightItem = forwardRef<HTMLDivElement, Props>(({ weight, onClick, onKeyDown, active }, fRef) => (
  <div
    tabIndex={0}
    key={weight}
    onKeyDown={onKeyDown}
    ref={fRef}
    className={cx(Styles.listItem, { [Styles.active]: active })}
    onClick={onClick}
    style={{
      fontWeight: parseInt(WeightValuesMap[weight]),
    }}
  >
    {weight}
  </div>
))
